import enTranslations from './en.json';
import esTranslations from './es.json';

const translations = {
  en: enTranslations,
  es: esTranslations
};

export default translations;